import React from 'react';
import "./headingNDescription.scss";

const HeadingNDescription = ({heading, description, style}) => {
  return <div className={"headingNDescriptionContainer"} style={style}>
    <h1>{heading}</h1>
    <p>{description}</p>
  </div>
}

export default HeadingNDescription